import React from 'react';
import './App.css';
import NetworkLineChart from './NetworkLineChart';


const App: React.FC = () => {
  return (
    <div className="App"> 
      <NetworkLineChart />
    </div>
  );
};

export default App;
